import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation CreateDepartment($model: DepartmentInput!) {
  createDepartment(department: $model){
    id
    name
    emails
    teams {
      id
      name
    }
    allTeamsOn
  }
}`;

function createDepartment(model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      model,
    },
  }).then((res) => res.data.createDepartment);
}

export default createDepartment;
